module.exports = __webpack_public_path__ + "static/media/client-header.726f9211.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/client-header.jpg
// module id = 159
// module chunks = 0